import React, { Component } from "react"

import UvpRate from "./UvpRate"
import { UserSvg, CloseSvg } from "../components/svg"

import { utils, sound } from "../constants"
import { createEmptyStake } from "../constants/values"
import { isMobile } from "../constants/utils"

const tempBoxStake = { ante: 0, trips: 0, bet: 0 }

class Boxes extends Component {
    constructor() {
        super()
        this.state = {

        }
    }

    soundBlock = () => {
        sound.play("blocked")
    }

    add = (type, box) => {

        const {
            setStakes,
            playerId,
            stakes,
            isChoice,
            active,
            max,
            chips,
            balance,
            toggleBalanceError,
            toggleMaxBetError,
            list,
            setList,
            boxPlayers
        } = this.props

        /* ===== Базовые проверки ===== */
        if (!isChoice || !stakes?.[box]) {
            this.soundBlock()
            return
        }

        const boxPlayer = boxPlayers?.[box]
        if (!boxPlayer || boxPlayer.playerId !== playerId) {
            this.soundBlock()
            return
        }

        const chipsList = utils.getChips(chips)
        const chip = chipsList.find(c => c.key === active)
        if (!chip) {
            this.soundBlock()
            return
        }

        const currentStake = stakes[box]
        const increment = chip.value

        /* trips можно ставить только если есть ante */
        if (type === "trips" && (currentStake.ante || 0) === 0) {
            this.soundBlock()
            return
        }

        const multiplier = type === "ante" ? 2 : 1
        const newValue = (currentStake[type] || 0) + increment

        /* Проверка max */
        if (newValue > parseInt(max)) {
            toggleMaxBetError()
            return
        }

        /* Проверка баланса */
        const required = increment * multiplier
        if (balance < required) {
            toggleBalanceError()
            return
        }

        /* Сохраняем предыдущий стейт для undo */
        const prev = [{
            box,
            stake: { ...currentStake }
        }]

        /* Обновляем только этот бокс */
        const nextStakes = stakes.map((s, i) =>
            i === box
                ? { ...s, [type]: newValue }
                : s
        )

        setStakes(nextStakes)
        setList([...(Array.isArray(list) ? list : []), { boxes: [box], prev }])
    }



    mobileRate = (box) => {

        const { isChoice, boxPlayers, playerId, stakes, backColor, chips } = this.props

        const boxPlayer = boxPlayers?.[box] || null

        if (!isChoice || !boxPlayer || boxPlayer.playerId !== playerId) {
            return null
        }

        // все боксы игрока
        const playerBoxes = boxPlayers.map((p, i) => (p?.playerId === playerId ? i : null)).filter(i => i !== null)

        let style = ""
        let secondStyle = playerBoxes.length === 3 ? "three-boxes" : playerBoxes.length === 2 ? "two-boxes" : ""

        if (playerBoxes.length > 1) {
            const min = Math.min(...playerBoxes)
            const max = Math.max(...playerBoxes)

            if (box === min) style = "right-rate"
            else if (box === max) style = "left-rate"
        }

        const boxStake = stakes?.[box] || createEmptyStake()

        return (
            <div className={`uvp-mobile-rates ${style} ${secondStyle}`} key={`m-rate-${box}`}>
                <UvpRate
                    ante={boxStake.ante || 0}
                    blind={boxStake.ante || 0}
                    trips={boxStake.trips || 0}
                    chips={chips}
                    isChoice={isChoice}
                    backColor={backColor}
                    add={type => this.add(type, box)}
                    isActive={true}
                />
            </div>
        )
    }


    boxRender = (box) => {

        const { dealerInfo, playerId, boxPlayers, stakes, boxJoin, boxLeft, isChoice, add, chips, gameplay, backColor, gameBox, result } = this.props

        const isActive = boxPlayers && boxPlayers[box] && boxPlayers[box].playerId === playerId
        const empty = boxPlayers && !boxPlayers[box]
        const boxStake = stakes && stakes[box] ? stakes[box] : tempBoxStake
        const boxStakeAnte = boxStake ? boxStake.ante : 0

        if (!boxPlayers || (boxPlayers && !boxPlayers[box])) {

            const style = empty && dealerInfo ? "active" : ""

            return (
                <div className="box-block-inner" onClick={() => (isChoice || dealerInfo) && boxJoin(box)}>
                    <div className={`box-join ${style}`}>
                        <UserSvg />
                    </div>
                </div>
            )
        }

        const player = boxPlayers[box]

        return (
            <div className="box-block-inner uvp-rate">
                <UvpRate
                    ante={boxStake.ante ? boxStake.ante : 0}
                    blind={boxStake.ante ? boxStake.ante : 0}
                    trips={boxStake.trips ? boxStake.trips : 0}
                    betX={player.betX}
                    pass={player.pass}
                    result={result[box] ? result[box] : null}
                    chips={chips}
                    isChoice={isChoice}
                    gameplay={gameplay}
                    action={player.action}
                    backColor={backColor}
                    add={type => this.add(type, box)}
                    isActive={!isMobile && isActive}
                    loading={box === gameBox}
                />

                <div className={`player-name ${isActive ? "active" : ""}`}>
                    {player.name}
                    {
                        isActive && (isChoice || (!isChoice && !boxStakeAnte)) ?
                            <div className="logout" onClick={() => boxLeft(box)}>
                                <CloseSvg />
                            </div>
                            : null
                    }

                </div>

            </div>
        )

    }

    render = () => {

        const { isChoice, dealerInfo, boxPlayers, playerId } = this.props

        let style = ''

        if (isChoice || dealerInfo) {
            style += ' box-choice'
        } else {
            style += ' box-game'
        }

        return (
            <>
                <div className={`uvp-boxes ${style}`}>
                    <div className="box-block second left">{this.boxRender(0)}</div>
                    <div className="box-block center">{this.boxRender(1)}</div>
                    <div className="box-block second right">{this.boxRender(2)}</div>
                </div>
                <div className="bottom-rates-mobile">
                    {
                        boxPlayers && Array.isArray(boxPlayers) && boxPlayers.map((p, i) => {
                            if (p && p.playerId === playerId) {
                                return this.mobileRate(i)
                            }
                        })
                    }
                </div>

            </>
        )

    }

}

export default Boxes